<template>
  <div class="thankYou-page">
    <div class="thankYou-pageContent">
      <div class="text-center">
        <!-- <h1 class="display-4 mb-4">Thank You!</h1> -->
        <h1 class="display-4 mb-4">Congratulations!</h1>
        <p class="lead txt--l txt--off-white">
          You are now a permit holder {{property}}
        </p>
        <hr class="border--bottom-gray border-top-0" />
        <p class="txt--ss">
          Having trouble?
          <a class="txt--primary" href="mailto:hello@piedparker.com?subject=Hello!">Contact us</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankYou",
  data() {
    return {
      property : '',
    };
  },
  created(){
    this.property = this.$route.query.property;
    if(this.property!='')
    {
      this.property = 'for '+this.property;
    }
  }
};
</script>

<style>
</style>